var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_5677_1749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 19.3872C13.406 19.3872 18.3327 11.5649 18.3327 7.16493C18.3327 5.69151 17.4547 4.27843 15.8919 3.23656C14.3291 2.19469 12.2095 1.60938 9.99935 1.60938C7.78921 1.60938 5.6696 2.19469 4.10679 3.23656C2.54399 4.27843 1.66602 5.69151 1.66602 7.16493C1.66602 11.5649 6.59268 19.3872 9.99935 19.3872Z",
    stroke: "#484888",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.9987 8.27691C10.9192 8.27691 11.6654 7.77945 11.6654 7.1658C11.6654 6.55215 10.9192 6.05469 9.9987 6.05469C9.07822 6.05469 8.33203 6.55215 8.33203 7.1658C8.33203 7.77945 9.07822 8.27691 9.9987 8.27691Z",
    stroke: "#484888",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5677_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.4b358b774380e5f15fadc688eafaf80d.svg";
export { ForwardRef as ReactComponent };